// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"561":"a216749f","744":"47359458","935":"8cf8ab44"}[chunkId] + ".chunk.js";
};